import { Grid } from '@mui/material'
import React, { useEffect } from 'react'
import { DefaultUserProfile } from '../../../../config/config';
import { Link } from 'react-router-dom';

type Props = {
  sortedData: any;
  selectCampaign?: any;
  sampleData?:boolean;
  platform?:string;
}

export const MostEngagingPosts = (props: Props) => {
  return (
    <div className="Most-Engaging-Posts">
      <Grid container spacing={2}>
        {props?.sortedData.map((item: any, index: number) => (
          <Grid key={index} item xs={12} md={4} lg={2}>
            <div className="grid-div align-items-start w-100">
              {props?.selectCampaign?.campaign_platform === 'Instagram' &&
                <><Link className='w-100' target='_blank' to={`https://www.instagram.com/p/${item?.shortcode}`}>
                  <img src={item?.gcp_display_url && item?.gcp_display_url ? item?.gcp_display_url : DefaultUserProfile.influencer_unknown_default}
                  alt={item?.username}
                  className="grid-image" />
                </Link>
               
                </>
              }
              {props?.selectCampaign?.campaign_platform === 'Youtube' &&
                <Link target='_blank' to={`https://www.youtube.com/watch?v=${item?.video_id}}`}>
                  <img src={item?.thumbnails ? item?.thumbnails : DefaultUserProfile.influencer_unknown_default} alt={item?.username} className="grid-image" />
                </Link>
              }
              {/* <span>{props?.selectCampaign?.campaign_platform === 'Instagram' ? item?.username : item?.title}</span> */}
              {props?.selectCampaign?.campaign_platform === 'Instagram' &&
                <Link target='_blank' className='btn btn-text-link mb-1' to={`https://www.instagram.com/${item?.username}`}>
                  {item?.username}
                </Link>
              }
              {props?.selectCampaign?.campaign_platform === 'Youtube' &&
                <Link target='_blank' className='btn btn-text-link mb-1' to={`https://www.youtube.com/${item?.custom_url}`}>
                  {item?.custom_url}
                </Link>
              }
              {props?.selectCampaign?.campaign_platform === 'Instagram' &&
                <span>ER  {item?.er}%</span>
              }
              {props?.selectCampaign?.campaign_platform === 'Youtube' &&
                <Link target='_blank' className='btn btn-text-link mb-1' to={`https://www.youtube.com/watch?v=${item?.video_id}}`}>
                  <span className='most-engaging-post-title'>{item?.title}</span>
                </Link>
              }
              {props?.selectCampaign?.campaign_platform === 'Youtube' &&
                <span>ER  {item?.er}%</span>
              }
            </div>
            
          </Grid>
        ))}
      </Grid>
    </div>
  )
}
